<template>
  <a-card :bordered="false" title="仓库实时直播">
    <div class="live-container">
      <!-- 视频播放区域 -->
      <div class="live-video-wrapper">
        <div id="video-container" />
        <div v-if="loading" class="loading-overlay">
          <a-spin size="large" tip="正在连接视频流..." />
        </div>
        <div v-if="error" class="error-overlay">
          <a-alert
            message="视频连接失败"
            :description="errorMessage"
            type="error"
            show-icon
          />
        </div>
      </div>

      <!-- 控制面板 -->
      <div class="live-controls">
        <a-space wrap>
          <a-button type="primary" @click="connectStream" :loading="connecting">
            重新连接
          </a-button>
          <a-button @click="toggleFullscreen">
            {{ isFullscreen ? '退出全屏' : '全屏' }}
          </a-button>
        </a-space>

        <!-- 摄像头切换 -->
        <div class="camera-list">
          <a-space wrap style="margin-top: 16px;">
            <a-tag
              v-for="camera in cameraList"
              :key="camera.serial"
              :color="currentDeviceSerial === camera.serial ? 'blue' : 'default'"
              @click="selectCamera(camera)"
              class="camera-tag"
            >
              {{ camera.name }}
            </a-tag>
          </a-space>
        </div>
      </div>
    </div>
  </a-card>
</template>

<script>
import { getVideoStream } from '@/api/ezviz'
import EzuikitFlv from 'ezuikit-flv'

export default {
  name: 'WarehouseLive',
  data () {
    return {
      videoPlayer: null,
      deviceSerial: '',
      channelNo: '1',
      currentDeviceSerial: '',
      currentDeviceName: '',
      currentStreamUrl: '',
      isConnected: false,
      isPlaying: true,
      isFullscreen: false,
      loading: false,
      connecting: false,
      error: false,
      errorMessage: '',
      cameraList: [
        { id: '1', name: '设备1', serial: 'BD2917557', location: '' },
        { id: '2', name: '设备2', serial: 'BC8056780', location: '' }
      ]
    }
  },
  mounted () {
    if (this.cameraList.length > 0) {
      this.selectCamera(this.cameraList[0])
    }
  },
  beforeDestroy () {
    if (this.videoPlayer) {
      this.videoPlayer = null
    }
  },
  methods: {
    initVideoPlayer (streamUrl) {
      // 清空容器内容
      const container = document.getElementById('video-container')
      if (container) {
        container.innerHTML = ''
      }
      this.videoPlayer = null

      this.videoPlayer = new EzuikitFlv({
        id: 'video-container',
        url: streamUrl,
        decoder: '/decoder.js',
        autoPlay: true
      })
      this.videoPlayer.on('error', (err) => {
        console.error('播放器错误:', err)
        this.error = true
        this.errorMessage = '视频播放失败: ' + (err.message || '未知错误')
      })
    },
    async connectStream () {
      if (!this.deviceSerial) {
        this.$message.warning('请输入设备序列号')
        return
      }

      this.connecting = true
      this.loading = true
      this.error = false

      try {
        const response = await getVideoStream({
          device_serial: this.deviceSerial,
          channel_no: this.channelNo,
          protocol: 'hls'
        })

        const streamUrl = response.data?.stream_url || response.stream_url
        if (streamUrl) {
          this.currentStreamUrl = streamUrl
          this.currentDeviceSerial = this.deviceSerial
          this.loading = false
          this.connecting = false
          this.isConnected = true
          this.isPlaying = true
          this.$nextTick(() => {
            this.initVideoPlayer(streamUrl)
          })
        } else {
          throw new Error('获取视频流地址失败')
        }
      } catch (e) {
        this.error = true
        this.errorMessage = e.message || '连接失败'
        this.loading = false
        this.connecting = false
        this.isConnected = false
      }
    },

    selectCamera (camera) {
      this.deviceSerial = camera.serial
      this.currentDeviceSerial = camera.serial
      this.currentDeviceName = camera.name
      this.connectStream()
    },

    toggleFullscreen () {
      const container = document.querySelector('.live-video-wrapper')
      if (!document.fullscreenElement) {
        container.requestFullscreen()
        this.isFullscreen = true
      } else {
        document.exitFullscreen()
        this.isFullscreen = false
      }
    }
  }
}
</script>

<style scoped>
.live-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.live-video-wrapper {
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  height: 600px;
}

#video-container {
  width: 100%;
  height: 100%;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
}

.error-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  padding: 20px;
}

.live-controls {
  padding: 16px;
  background: #f5f5f5;
  border-radius: 8px;
}

.camera-list {
  margin-top: 16px;
}

.camera-tag {
  cursor: pointer;
  padding: 4px 12px;
}
</style>
